<template>
  <div>
    <v-dialog v-model="showDialog" :fullscreen="true" @click:outside="close">
      <v-card color="bodyBG" tile>
        <v-card-text class="pa-0">
          <PDFViewer
            :src="src"
            :blob="blob"
            :fileName="fileName"
            @close="close"
            @pdfOpened="$emit('pdfOpened', true)"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import PDFViewer from "@/components/shared/PDF/PDFViewer.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    src: {
      type: String,
      default: null,
    },
    blob: {
      type: Blob,
    },
    fileName: {
      type: String,
    },
  },
  methods: {
    close() {
      this.showDialog = false;
    },
  },
  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    PDFViewer,
  },
});
</script>
